import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { GameEnvironmentsOverviewCard } from './gameEnvironmentsOverviewCard';
import { PublisherViewHeader } from '../../components/publisher-view-header/publisher-view-header';
import { GameEnvironmentCard } from './gameEnvironmentCard';
import { NewGameEnvironmentCard } from './newGameEnvironmentCard';
import { FloatingActionButton } from '@yakoffice/floating-actions';


interface PropsType {
    gameEnvironments: IGameEnvironment[];
    updateCallbackTrigger: () => void;
    activeGameEnvironment?: IGameEnvironment | null;
    setActiveGameEnvironment: (gameEnvironment: IGameEnvironment | undefined) => void;
    newGameEnvironment: boolean;
    setNewGameEnvironment: (value: boolean) => void;
}

export const GameEnvironments: FC<PropsType> = observer((props) => {


    const updateCallbackTrigger = (clearActiveGameEnvironment?: boolean) => {
        props.updateCallbackTrigger();
        clearActiveGameEnvironment && props.setActiveGameEnvironment(undefined);
    };

    const updateNewGameEnvironmentCallback = (clearActiveGameEnvironment?: boolean) => {
        props.updateCallbackTrigger();
        clearActiveGameEnvironment && props.setActiveGameEnvironment(undefined);
        props.setNewGameEnvironment(false);
    };

    const createNewGameEnvironment = () => {
        props.setActiveGameEnvironment(undefined);
        props.setNewGameEnvironment(true);
    };

    return (
        <div id="gameEnvironments">
            <PublisherViewHeader title="Game Environments" />
            <Container fluid>
                <Row>
                    <Col xl={4} lg={5} md={6} className="scrollable">
                        {props.gameEnvironments.map((gameEnvironment) => (
                            <div
                                onClick={() => {
                                    props.setNewGameEnvironment(false);
                                    props.setActiveGameEnvironment(gameEnvironment);
                                }}
                                key={gameEnvironment.id}
                            >
                                <GameEnvironmentsOverviewCard gameEnvironment={gameEnvironment}
                                                              active={props.activeGameEnvironment === gameEnvironment} />
                            </div>
                        ))}
                    </Col>
                    <Col xl={8} lg={7} md={6} className="">
                        <div className="">
                            {props.activeGameEnvironment &&
                                <GameEnvironmentCard gameEnvironment={props.activeGameEnvironment}
                                                     updateCallbackTrigger={updateCallbackTrigger} />}
                            {props.newGameEnvironment &&
                                <NewGameEnvironmentCard updateCallbackTrigger={updateNewGameEnvironmentCallback} />}
                        </div>
                    </Col>
                </Row>
                <FloatingActionButton
                    callback={createNewGameEnvironment}
                    buttonContent={
                        <>
                            <i className="fas fa-plus font-light me-2" /> New Environment
                        </>
                    }
                />
            </Container>
        </div>
    );
});
